var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.975.73c-.123-.514-.687-.863-1.199-.681 0 0-22.158 7.82-22.162 7.823a.938.938 0 00-.608.822.955.955 0 00.529.88l8.583 4.006 4.189-4.189c.83-.83 2.154.454 1.303 1.303l-4.19 4.19s4.002 8.573 4.01 8.587a.987.987 0 00.832.528c.38.018.732-.273.869-.614l7.82-22.16a.864.864 0 00.024-.495z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.005,
    y1: 11.803,
    x2: 24,
    y2: 11.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6C28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA9865"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGold);
export default __webpack_public_path__ + "static/media/send-gold.a9f3ded1a1fe9477b8e8e19c6a32d5ec.svg";
export { ForwardRef as ReactComponent };